import { useState } from 'react';
import { createWithRemoteLoader } from '@kne/remote-loader';
import { Space } from 'antd';
import ExpectSalary from './ExpectSalary';
import CardInfo from './CardInfo';
import defaultFormConfig from './defaultFormConfig';
import style from './style.module.scss';

const defaultExpansion = { ExpectSalary, CardInfo };

const defaultColumn = [
  {
    width: 480,
    col: 1
  },
  {
    width: 1088,
    col: 2
  },
  {
    width: 1300,
    col: 3
  }
];

export const ResumeFormInner = createWithRemoteLoader({
  modules: ['components-core:FormInfo', 'components-core:Enum', 'components-core:FormInfo@useFormContext']
})(({ remoteModules, overConfig }) => {
  const [state, setState] = useState({});
  const [FormInfo, Enum, useFormContext] = remoteModules;
  const { List } = FormInfo;
  const fields = Object.assign({}, FormInfo.fields, defaultExpansion);
  const context = useFormContext();

  const config = overConfig(defaultFormConfig);
  const renderField = ({ fieldType, name, label, rule, interceptor, enum: enumConfig, props, computedProps }) => {
    const CurrentFieldComponent = fields[fieldType] || fields['Input'];

    const renderField = contextValue => (
      <CurrentFieldComponent
        {...Object.assign(
          {},
          props,
          typeof computedProps === 'function'
            ? computedProps(
                Object.assign({}, props, contextValue, {
                  context,
                  state,
                  setState
                })
              )
            : {}
        )}
        name={name}
        label={label}
        rule={rule}
        interceptor={interceptor}
      />
    );

    return enumConfig ? <Enum {...Object.assign({}, enumConfig)}>{data => renderField({ enum: data })}</Enum> : renderField();
  };

  return (
    <Space direction={'vertical'} size={32}>
      {config.map(({ type, fields, title, ...others }, index) => {
        const listFields = (fields || []).map(item => renderField(item));
        if (type === 'list') {
          return (
            <List
              {...others}
              title={title}
              column={{ columns: defaultColumn }}
              list={listFields}
              deleteButtonProps={{
                isModal: document.documentElement.clientWidth < 768
              }}
            />
          );
        }

        return <FormInfo {...others} title={title} column={{ columns: defaultColumn }} list={listFields} />;
      })}
    </Space>
  );
});

ResumeFormInner.defaultProps = {
  overConfig: config => config
};

const ResumeForm = createWithRemoteLoader({
  modules: ['components-core:FormInfo@Form', 'components-core:FormInfo@SubmitButton']
})(({ remoteModules, overConfig, ...props }) => {
  const [Form, SubmitButton] = remoteModules;

  return (
    <Form {...props}>
      <ResumeFormInner overConfig={overConfig} />
      <SubmitButton className={style['submit-btn']}>提 交</SubmitButton>
    </Form>
  );
});

export default ResumeForm;

export { default as enums } from './enums.json';
export * as resumeTransform from './transform.js';
